import React, { useState } from "react"
import moment from "moment"
import NumberFormat from "../../../utils/numberFormat"
import { useNavigate } from "react-router-dom"
// import RightArrow from "../../assets/icons/rightarrow.svg";
// import LeftArrow from "../../assets/icons/lefarrow.svg";
// import redLeftArrow from "../../assets/icons/redLeftArrow.svg";
// import disabledRightArrow from "../../assets/icons/disabledRightArrow.svg";

const SoaTable = ({
  data,
  pagination,
  onPageChange,
  hidePagination = false,
  activeTab = "receivable",
  isLoading = false,
  position = false,
  currFormat,
  ageingPeriod,
}) => {
  console.log("pagination", pagination, currFormat)
  const handlePageChange = page => {
    if (onPageChange) {
      onPageChange(page)
    }
  }
  const [openLedgerId, setOpenLedgerId] = useState(null)
  const navigate = useNavigate()

  const desimalrange = localStorage.getItem("desimalrange")
  // Modified to handle both credit and debit values
  const calculateAmount = (partialPayments, field) => {
    if (!partialPayments) return 0

    console.log(`partialPayments j`, partialPayments, field)

    return partialPayments.reduce((sum, payment) => {
      if (payment.type === "debit") {
        return Number(sum) + Number(payment[field] ?? 0)
      } else if (payment.type === "credit") {
        return sum - Number(payment[field] ?? 0)
      }
      return sum
    }, 0)
  }

  // Format amount with DR/CR suffix
  const formatAmountWithSuffix = amount => {
    if (
      amount === 0 ||
      amount === null ||
      amount === undefined ||
      amount === "" ||
      amount === "NaN"
    )
      return NumberFormat(0, desimalrange || 2, desimalrange || 2)

    if (amount < 0) {
      return `${NumberFormat(
        Math.abs(amount),
        desimalrange || 2,
        desimalrange || 2
      )} CR`
    } else {
      return `${NumberFormat(amount, desimalrange || 2, desimalrange || 2)} DR`
    }
  }

  const calculatePendingSumByType = (payments = [], type) =>
    payments.reduce(
      (total, { type: paymentType, total_pending_amount = 0 }) =>
        paymentType === type ? total + total_pending_amount : total,
      0
    )

  const renderPagination = () => {
    const pagesToShow = []
    const totalPages = pagination?.last_page || 1
    const currentPage = pagination?.current_page || 1

    if (totalPages < 7) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i)
      }
    } else {
      if (
        currentPage % 5 >= 0 &&
        currentPage > 4 &&
        currentPage + 2 < totalPages
      ) {
        pagesToShow.push(
          1,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          totalPages
        )
      } else if (
        currentPage % 5 >= 0 &&
        currentPage > 4 &&
        currentPage + 2 >= totalPages
      ) {
        pagesToShow.push(
          1,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        )
      } else {
        pagesToShow.push(1, 2, 3, 4, 5, totalPages)
      }
    }

    return (
      <span>
        {pagesToShow.map((page, index) => (
          <span key={index} onClick={() => handlePageChange(page)}>
            {pagesToShow[index - 1] + 2 < page ? (
              <span>
                <button className={`${currentPage === page ? "active" : ""}`}>
                  ...
                </button>
                <button className={`${currentPage === page ? "active" : ""}`}>
                  {page}
                </button>
              </span>
            ) : (
              <button className={`${currentPage === page ? "active" : ""}`}>
                {page}
              </button>
            )}
          </span>
        ))}
      </span>
    )
  }

  return (
    <div className="soa-table-container">
      <table className="table soa-table fs-12">
        <thead className="need-to-be-a-sticky">
          <tr>
            <th style={{ color: "#4B80EE", width: "220px" }}>
              Party's Name (Ref)
            </th>
            <th></th>
            <th className="styles-custom" style={{ color: "#4B80EE" }}>
              Doc Type
            </th>
            {/* <th className="styles-custom" style={{ color: "#4B80EE" }}>
              Doc Num
            </th> */}
            <th className="styles-custom" style={{ color: "#4B80EE" }}>
              Date
            </th>
            <th
              className="text-end"
              style={{ color: "#4B80EE", width: "140px" }}
            >
              Bill Amount
            </th>
            {/* <th className="text-end" style={{ color: "#4B80EE" }}>
              Paid Amount
            </th> */}
            <th className="text-end" style={{ color: "#4B80EE" }}>
              Pending Amount
            </th>
            {currFormat == 3 && ageingPeriod?.length ? (
              <>
                {ageingPeriod.map((period, index) => (
                  <>
                    <th className="text-end" style={{ color: "#4B80EE" }}>
                      {period?.from_days == 0
                        ? `< ${period?.to_days} Days`
                        : period?.to_days == 0
                        ? `> ${period?.from_days} Days`
                        : `${period?.from_days} to ${period?.to_days} Days`}
                    </th>
                  </>
                ))}
              </>
            ) : (
              <></>
            )}
            {/* {currFormat == 3 && (
              <>
                <th className="text-end" style={{ color: "#4B80EE" }}>
                  &lt; 30 Days
                </th>
                <th className="text-end" style={{ color: "#4B80EE" }}>
                  30 to 60 Days
                </th>
                <th className="text-end" style={{ color: "#4B80EE" }}>
                  60 to 60 Days
                </th>
                <th className="text-end" style={{ color: "#4B80EE" }}>
                  &gt; 90 Days
                </th>
              </>
            )} */}
            <th className="text-end" style={{ color: "#4B80EE" }}>
              Due Date
            </th>
            {currFormat != 3 && (
              <th className="text-end" style={{ color: "#4B80EE" }}>
                Over due days
              </th>
            )}
            {/* <th></th> */}
            {/* <th className="text-end" style={{ color: "#4B80EE" }}>
              &gt; 90 Days
            </th>
            <th className="text-end" style={{ color: "#4B80EE" }}>
              Due On
            </th> */}
          </tr>
        </thead>
        <tbody>
          {data?.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center py-4">
                No Data Found
              </td>
            </tr>
          ) : (
            data?.map(ledger => (
              <React.Fragment key={ledger.ledger_id}>
                {/* Main Ledger Row - Show only ledger name */}
                <tr
                  className="main-row"
                  onClick={() =>
                    setOpenLedgerId(
                      openLedgerId === ledger.ledger_id
                        ? null
                        : ledger.ledger_id
                    )
                  }
                >
                  <td
                    colSpan={3}
                    style={{
                      width: "300px",
                      wordBreak: "break-word",
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          display: "inline-flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "20px",
                          height: "20px",
                          marginRight: "8px",
                          borderRadius: "4px",
                          color: "#4B80EE",
                          fontWeight: "bold",
                        }}
                      >
                        {openLedgerId === ledger.ledger_id ? "-" : "+"}
                      </span>
                      <div>{ledger.ledger_name}</div>
                    </div>
                  </td>
                  <td className="text-end" style={{ width: "140px" }}>
                    {/* {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total_pending_amount"
                      )
                    )} */}
                  </td>

                  {/* <td className="text-end"> */}
                  {/* {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "pending_less_than_30_days"
                      )
                    )} */}
                  {/* </td> */}
                  <td className="text-end">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total"
                      )
                    )}
                  </td>
                  <td className="text-end">
                    
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(
                          v => v.partial_payments
                        ),
                        "total_pending_amount"
                      )
                    )}
                  </td>
                  {/* <td></td> */}
                  <td className="text-end">
                    
                  </td>
                  {currFormat == 3 && ageingPeriod?.length ? (
                    <>
                      {ageingPeriod.map((period, index) => (
                        <>
                          <td></td>
                        </>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                  {/* {currFormat == 3 && (
                    <>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </>
                  )} */}
                  {currFormat != 3 && <td className="text-end"></td>}
                </tr>

                {/* Voucher entries */}
                {openLedgerId === ledger.ledger_id && (
                  <>
                    {ledger.voucher_entries?.map((voucher, index) => (
                      <React.Fragment key={voucher.voucher_id}>
                        <tr className="voucher-row">
                          {voucher?.voucher_type == "Opening Balance" ? (
                            <td style={{ paddingLeft: "40px" }}>
                              {voucher.voucher_code}
                            </td>
                          ) : (
                            <td
                              className="pointer"
                              style={{ paddingLeft: "40px", color: "#4B80EE" }}
                              onClick={() =>
                                navigate(
                                  `/finance-voucher/view/${voucher.voucher_id}`
                                )
                              }
                            >
                              {voucher.voucher_code}
                            </td>
                          )}
                          <td></td>
                          <td>{voucher?.voucher_type}</td>
                          <td>
                            {moment(voucher.voucher_date).format("DD-MM-YYYY")}
                          </td>
                          <td className="text-end">
                            {NumberFormat(
                              Number(voucher?.partial_payments[0]?.total ?? 0),
                              desimalrange || 2,
                              desimalrange || 2
                            )}{" "}
                            {voucher?.partial_payments[0]?.type === "debit"
                              ? "DR"
                              : "CR"}
                            {/* {formatAmountWithSuffix(
                              calculateAmount(
                                voucher.partial_payments,
                                "total_pending_amount"
                              )
                            )} */}
                          </td>
                          {/* <td className="text-end">
                            {NumberFormat(
                              Number(voucher?.partial_payments[0]?.total ?? 0) -
                                Number(
                                  voucher?.partial_payments?.[0]
                                    ?.total_pending_amount ?? 0
                                ),
                              desimalrange || 2,
                              desimalrange || 2
                            )}{" "}
                            {voucher?.partial_payments[0]?.type === "debit"
                              ? "DR"
                              : "CR"}
                          </td> */}
                          <td className="text-end">
                            {NumberFormat(
                              Number(
                                voucher?.partial_payments[0]
                                  ?.total_pending_amount ?? 0
                              ),
                              desimalrange || 2,
                              desimalrange || 2
                            )}{" "}
                            {voucher?.partial_payments[0]?.type === "debit"
                              ? "DR"
                              : "CR"}
                            {/* {formatAmountWithSuffix(
                              calculateAmount(
                                voucher.partial_payments,
                                "pending_less_than_30_days"
                              )
                            )} */}
                          </td>
                          {/* <td className="text-end">
                            {formatAmountWithSuffix(
                              calculateAmount(
                                voucher.partial_payments,
                                "pending_30_to_60_days"
                              )
                            )}
                          </td>
                          <td className="text-end">
                            {formatAmountWithSuffix(
                              calculateAmount(
                                voucher.partial_payments,
                                "pending_60_to_90_days"
                              )
                            )}
                          </td>
                          <td className="text-end">
                            {formatAmountWithSuffix(
                              calculateAmount(
                                voucher.partial_payments,
                                "pending_greater_than_90_days"
                              )
                            )}
                          </td> */}
                          {currFormat == 3 && ageingPeriod?.length ? (
                            <>
                              {/* {ageingPeriod.map((period, index) => (
                                <>
                                  <td className="text-end">
                                    {formatAmountWithSuffix(
                                      calculateAmount(
                                        voucher.partial_payments,
                                        `${
                                          period?.to_days == 0
                                            ? `pending_over_${period?.from_days}_days`
                                            : `pending_${period?.from_days}_to_${period?.to_days}_days`
                                        }`
                                      )
                                    ) || 0}
                                  </td>
                                </>
                              ))} */}

                              {ageingPeriod.map((period, index) => {
                                const field =
                                  period?.to_days == 0
                                    ? `pending_over_${period?.from_days}_days`
                                    : `pending_${period?.from_days}_to_${period?.to_days}_days`

                                return (
                                  <td key={index} className="text-end">
                                    {formatAmountWithSuffix(
                                      calculateAmount(
                                        voucher.partial_payments,
                                        field
                                      )
                                    ) || 0}
                                  </td>
                                )
                              })}
                            </>
                          ) : (
                            <></>
                          )}
                          {/* {currFormat == 3 && (
                            <>
                              <td className="text-end">
                                {formatAmountWithSuffix(
                                  calculateAmount(
                                    voucher.partial_payments,
                                    "pending_less_than_30_days"
                                  )
                                )}
                              </td>
                              <td className="text-end">
                                {formatAmountWithSuffix(
                                  calculateAmount(
                                    voucher.partial_payments,
                                    "pending_30_to_60_days"
                                  )
                                )}
                              </td>
                              <td className="text-end">
                                {formatAmountWithSuffix(
                                  calculateAmount(
                                    voucher.partial_payments,
                                    "pending_60_to_90_days"
                                  )
                                )}
                              </td>
                              <td className="text-end">
                                {formatAmountWithSuffix(
                                  calculateAmount(
                                    voucher.partial_payments,
                                    "pending_greater_than_90_days"
                                  )
                                )}
                              </td>
                            </>
                          )} */}
                          <td className="text-end">
                            {moment(
                              voucher?.partial_payments[0]?.due_date
                            ).format("DD-MM-YYYY")}
                          </td>
                          {currFormat != 3 && (
                            <td className="text-end">
                              {moment(
                                voucher?.partial_payments[0]?.due_date
                              ).diff(moment(), "days")}
                            </td>
                          )}
                        </tr>
                        {currFormat == 2 &&
                        voucher?.partial_payments[0]?.against_payments
                          ?.length ? (
                          <>
                            {voucher?.partial_payments[0]?.against_payments?.map(
                              (partial, index) => (
                                <tr className="voucher-row" key={index}>
                                  <td
                                    style={{
                                      paddingLeft: "80px",
                                    }}
                                  >
                                    {moment(partial?.voucher?.date).format(
                                      "DD-MM-YYYY"
                                    )}{" "}
                                    {
                                      partial?.voucher?.voucher_type
                                        ?.voucher_type
                                    }
                                  </td>
                                  <td>
                                    {/* {moment(partial?.date).format("DD-MM-YYYY")}{" "} */}
                                  </td>
                                  <td
                                    className="pointer"
                                    style={{
                                      paddingLeft: "40px",
                                      color: "#4B80EE",
                                    }}
                                    onClick={() =>
                                      navigate(
                                        `/finance-voucher/view/${partial.voucher_id}`
                                      )
                                    }
                                  >
                                    {partial?.voucher?.ref_number}
                                  </td>
                                  <td>
                                    {partial?.amount}{" "}
                                    {partial?.credit_debit === "debit"
                                      ? "DR"
                                      : "CR"}
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              )
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </React.Fragment>
                    ))}
                    <React.Fragment>
                      <tr className="voucher-row fw-bold-700 fs-12">
                        <td style={{ paddingLeft: "40px" }}>Total</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-end">
                          {/* {NumberFormat(
                            calculatePendingSumByType(
                              ledger.voucher_entries.flatMap(
                                v => v.partial_payments
                              ),
                              "debit"
                            ),
                            desimalrange || 2,
                            desimalrange || 2
                          )} */}
                          {formatAmountWithSuffix(
                            calculateAmount(
                              ledger.voucher_entries.flatMap(
                                v => v.partial_payments
                              ),
                              "total"
                            )
                          )}
                        </td>
                        {/* <td className="text-end">
                        
                          {formatAmountWithSuffix(
                            calculateAmount(
                              ledger.voucher_entries.flatMap(
                                v => v.partial_payments
                              ),
                              "total"
                            ) -
                              calculateAmount(
                                ledger.voucher_entries.flatMap(
                                  v => v.partial_payments
                                ),
                                "total_pending_amount"
                              )
                          )}
                        </td> */}
                        <td className="text-end">
                          {formatAmountWithSuffix(
                            calculateAmount(
                              ledger.voucher_entries.flatMap(
                                v => v.partial_payments
                              ),
                              "total_pending_amount"
                            )
                          )}
                        </td>
                        <td className="text-end"></td>
                        {/* {currFormat == 3 && (
                          <>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                          </>
                        )} */}
                        {currFormat == 3 && ageingPeriod?.length ? (
                          <>
                            {ageingPeriod.map((period, index) => (
                              <>
                                <td></td>
                              </>
                            ))}
                          </>
                        ) : (
                          <></>
                        )}
                        {currFormat != 3 && <td className="text-end"></td>}
                      </tr>
                    </React.Fragment>

                    {/* <React.Fragment>
                      <tr className="voucher-row fw-bold-700 fs-12">
                        <td style={{ paddingLeft: "40px" }}>Closing Balance</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-end">
                         
                        </td>
                        <td className="text-end">
                          {formatAmountWithSuffix(
                            calculateAmount(
                              ledger.voucher_entries.flatMap(
                                v => v.partial_payments
                              ),
                              "total_pending_amount"
                            )
                          )}
                        </td>

                        <td className="text-end"></td>
                        <td className="text-end"></td>
                      </tr>
                    </React.Fragment> */}
                  </>
                )}
                {/* {isLoading ? (
                                  <div class="loader-row">
                                    <div class={`bouncing-loader ${position ? "position-of" : "position-out"}`}>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )} */}

                {/* Difference row - shows totals for all vouchers */}
                {/* <tr className="difference-row" style={{ color: 'red' }}>
                  <td colSpan="3" className="text-end"></td>
                  <td className="text-end">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(v => v.partial_payments),
                        'total_pending_amount'
                      )
                    )}
                  </td>
                  <td className="text-end">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(v => v.partial_payments),
                        'pending_less_than_30_days'
                      )
                    )}
                  </td>
                  <td className="text-end">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(v => v.partial_payments),
                        'pending_30_to_60_days'
                      )
                    )}
                  </td>
                  <td className="text-end">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(v => v.partial_payments),
                        'pending_60_to_90_days'
                      )
                    )}
                  </td>
                  <td className="text-end">
                    {formatAmountWithSuffix(
                      calculateAmount(
                        ledger.voucher_entries?.flatMap(v => v.partial_payments),
                        'pending_greater_than_90_days'
                      )
                    )}
                  </td>
                  <td className="text-end"></td>
                </tr> */}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>

      {isLoading ? (
        <div class="loader-row">
          <div
            class={`bouncing-loader ${
              position ? "position-of" : "position-out"
            }`}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : pagination?.last_page > 1 ? (
        <div className="d-flex justify-content-center">End of List</div>
      ) : (
        <></>
      )}

      {/* Updated Pagination */}
      {pagination?.total && pagination.total > 16 && !hidePagination ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="my-2 pagination-details"
        >
          <div className="showing-page">
            Showing {pagination.from}-{pagination.to} from {pagination.total}
          </div>
          <div>
            <button
              type="button"
              className="left-pagination-button"
              disabled={pagination.current_page === 1}
              onClick={() => handlePageChange(pagination.current_page - 1)}
            >
              {/* <img
                src={pagination.current_page === 1 ? LeftArrow : redLeftArrow}
                alt="Left Arrow"
              />{" "} */}
              Back
            </button>

            <span>{renderPagination()}</span>
            <button
              type="button"
              className="right-pagination-button"
              disabled={pagination.current_page === pagination.last_page}
              onClick={() => handlePageChange(pagination.current_page + 1)}
            >
              Next{" "}
              {/* <img
                src={
                  pagination.current_page === pagination.last_page
                    ? disabledRightArrow
                    : RightArrow
                }
                alt="right Arrow"
              /> */}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default SoaTable
